// Components
import Radio from '../../../atoms/Radio/Radio';

// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './BooleanField.module.css';

/**
 * BatchActionBooleanInput - Boolean radio input component for batch actions (Oui/Non)
 * @param {object} props
 * @param {'oui' | 'non'} [props.value] - Current boolean value (true, false, or null)
 * @param {(value: 'oui' | 'non') => void} props.onChange - Change handler
 * @param {string} [props.name] - Input name attribute
 * @param {boolean} [props.disabled] - Whether input is disabled
 * @param {boolean} [props.isReadOnly] - Locked; value remains in form
 * @param {{message?: string}} [props.error] - Validation error
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} BatchActionBooleanInput component
 */
function BooleanField({
  value = 'oui',
  onChange,
  name,
  disabled = false,
  isReadOnly = false,
  error = null,
  className = '',
}) {
  return (
    <div className={cn([styles.wrapper, className])}>
      <div className={styles['radio-group']}>
        <div className={styles['radio-item']}>
          <Radio
            id={`${name}-boolean-oui`}
            name={`${name}-boolean-oui`}
            value="oui"
            checked={value === 'oui'}
            onChange={() => { if (!isReadOnly) onChange('oui'); }}
            disabled={disabled}
            isReadOnly={isReadOnly}
            label="Oui"
            size="small"
            theme="black"
          />
        </div>

        <div className={styles['radio-item']}>
          <Radio
            id={`${name}-boolean-non`}
            name={`${name}-boolean-non`}
            value="non"
            checked={value === 'non'}
            onChange={() => { if (!isReadOnly) onChange('non'); }}
            disabled={disabled}
            isReadOnly={isReadOnly}
            label="Non"
            size="small"
            theme="black"
          />
        </div>
      </div>

      {error && (
        <div className={styles.error} role="alert">
          {error.message}
        </div>
      )}
    </div>
  );
}

export default BooleanField;
